<template>
  <div class="h-full flex">
    <el-card class="h-full mr-10px w-420px">
      <div class="flex items-center">
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">{{
          `${pageTitle}库`
        }}</span>
        <el-dropdown>
          <span class="el-dropdown-link">
            <i
              class="iconfont icon-line-moreVertical text-14px font-bold text-hex-$contentTextColor"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :class="{ active: menuTreeType === '' }"
              @click.native="menuTreeType = ''"
              >显示全部</el-dropdown-item
            >
            <el-dropdown-item
              :class="{ active: menuTreeType === 'pr' }"
              @click.native="menuTreeType = 'pr'"
              >显示模型</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex mt-10px mb-10px">
        <selectStandardId
          @updateStandardList="updateStandardList"
          @updateStandardId="updateStandardId"
          :selectStandardProps="{ width: 'w-120px' }"
        />
        <el-input
          clearable
          placeholder="文档名称或编码"
          class="flex-1 mr-10px ml-10px"
          v-model="treeKeyword"
        />
        <el-button
          size="small"
          class="iconfont icon-line-search"
          type="primary"
          @click="searchTree('search')"
        ></el-button>
        <!-- <el-button
          size="small"
          type="primary"
          class="iconfont icon-line-circleAdd"
          @click="addSourceMaterial"
          :disabled="!$hasAccess('create')"
        ></el-button> -->
      </div>
      <el-tree
        v-if="treeStandBy"
        ref="modelTreeTree"
        :default-expand-all="defaultExpandAll"
        :data="treeData"
        class="modelTree-tree overflow-y-auto"
        :props="{
          children: 'childrens',
          label: 'name',
          isLeaf: 'isleaf',
        }"
        highlight-current
        node-key="id"
        :expand-on-click-node="false"
        :filter-node-method="filterTree"
        :default-expanded-keys="defaultExpandIds"
        :current-node-key="currentNodeKey"
        @node-click="handleNodeClick"
        v-loading="treeLoading"
        :lazy="isTreeLazy"
        :load="loadTreeData"
      >
        <div slot-scope="{ node, data }" class="flex items-center flex-1 overflow-x-hidden">
          <el-tooltip effect="dark" :open-delay="400" :content="node.label" placement="top">
            <span class="text-sm flex-1 mr-10px truncate">{{ node.label }}</span>
          </el-tooltip>
          <el-dropdown class="mr-10px" @command="($event) => handleCommand($event, node, data)">
            <i class="iconfont icon-line-moreVertical"></i>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="create" :disabled="!$hasAccess('create')"
                >新增</el-dropdown-item
              > -->
              <el-dropdown-item v-if="data.id" command="edit" :disabled="!$hasAccess('update')"
                >编辑</el-dropdown-item
              >
              <el-dropdown-item v-if="data.id" command="delete" :disabled="!$hasAccess('delete')"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-tree>
    </el-card>
    <el-card class="h-full flex-1">
      <div class="mb-20px flex justify-between">
        <div>
          <el-input
            size="small"
            clearable
            :placeholder="`请输入${pageTitle}名称`"
            class="!w-280px mr-10px"
            v-model="searchForm.name"
          />
          <el-button
            size="small"
            type="primary"
            @click="searchList()"
            :disabled="!$hasAccess('read')"
            >搜索</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="resetSearch()"
            :disabled="!$hasAccess('read')"
            >重置</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="createModelBase"
            :disabled="!$hasAccess('create')"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            @click="batchDeleteModelBase"
            :disabled="!$hasAccess('delete')"
            >删除</el-button
          >
          <el-button
            size="small"
            @click="exportModel(selection)"
            :loading="exportLoading"
            :disabled="!$hasAccess('export')"
            >导出</el-button
          >
          <el-button size="small" @click="importModel(selection)" :disabled="!$hasAccess('import')"
            >导入</el-button
          >
          <el-button
            size="small"
            @click="downloadFile"
            :disabled="!$hasAccess('download')"
            :loading="downLoading"
            >下载文件</el-button
          >
        </div>
      </div>
      <section
        v-loading="tableLoading"
        :gutter="10"
        class="relative h-[calc(100%-85px)] flex justify-start content-start flex-wrap overflow-y-auto text-12px"
      >
        <el-card
          v-for="(value, keys) in tableData"
          :key="keys"
          class="card__body--nopadding
            2xl:w-[calc(20%-20px)] 2xl:h-212px 2xl:text-14px
            xl:w-[calc(25%-20px)] xl:h-131px xl:text-14px
            md:w-[calc(33%-20px)] md:h-127px md:text-12px
            mr-20px mb-20px"
        >
          <div class="w-full h-full">
            <div class="to-model-preview h-[calc(100%-42px)]" @click="openModelView(value)">
              <el-image class="w-full h-full" :src="value.pathUrl" fit="cover">
                <div slot="error" class="image-slot w-full h-full flex justify-center items-center">
                  <i class="el-icon-picture-outline text-60px"></i></div
              ></el-image>
            </div>
            <div
              class="w-full h-42px flex justify-between px-6px
                bg-hex-c4c4c4cc model_message_wrap text-white leading-24px"
            >
              <el-checkbox
                class="w-14px !mr-6px"
                v-model="value.isCheck"
                @change="checkBoxChange(value)"
              ></el-checkbox>
              <div class="max-w-[calc(100%-20px)] flex-1 pr-4px">
                <div class="w-full flex justify-between items-center">
                  <el-tooltip
                    effect="dark"
                    :open-delay="400"
                    :content="value[standardDocumentCode]"
                    placement="top"
                  >
                    <span class="flex-1 truncate">{{ value[standardDocumentCode] }}</span>
                  </el-tooltip>
                  <div class="w-72px">
                    <span
                      :class="!$hasAccess('update') ? 'cursor-not-allowed' : 'cursor-pointer'"
                      @click="editModelBase(value)"
                      >编辑</span
                    ><span class="mx-6px">|</span
                    ><span
                      :class="!$hasAccess('delete') ? 'cursor-not-allowed' : 'cursor-pointer'"
                      @click="deleteModelBase(value.id)"
                      >删除</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <div class="el-tree__empty-text" v-if="!tableData.length">暂无数据</div>
      </section>
      <el-pagination
        class="text-right relative
          before:content-[''] before:w-full before:h-20px before:absolute before:top-[-20px] before:left-0 before:bg-$contentBgColor"
        background
        @size-change="searchList()"
        @current-change="findList()"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :total="page.pageTotal"
        layout="sizes, total, prev, pager, next, jumper"
        :pager-count="5"
        :page-sizes="[15, 30, 50, 100]"
      >
      </el-pagination>
      <wiz-upload-file
        v-dialogDrag
        v-if="showUploadExcelDialog"
        @refreshList="resetSearch"
        @exportTemplate="exportTemplate"
        @importTemplate="importTemplate"
        @exportResults="exportResults"
        :pageInfo="pageInfo"
        :uploadFileProps="uploadFileProps"
      ></wiz-upload-file>
      <operate-model-tree-dialog
        v-if="showOperateSourceMaterialDialog"
        :pageInfo="treeDialogQuery"
        :moduleConfig="moduleConfig"
        :modelTreeProps="modelTreeProps"
        :modelTreeForm="modelTreeForm"
        @closeModelTreeDialog="closeModelTreeDialog"
      ></operate-model-tree-dialog>
      <operate-model-dialog
        v-if="showOperateModelDialog"
        :currentTreeSelect="currentTreeSelect"
        :treeData="treeData"
        :currentStandardItemCode="currentStandardItemCode"
        :moduleConfig="moduleConfig"
        :modelProps="modelProps"
        :modelForm="modelForm"
        @closeModelDialog="closeModelDialog"
      ></operate-model-dialog>
      <function-config v-if="configDialogShow" :visible.sync="configDialogShow" />
    </el-card>
  </div>
</template>
<script>
import {
  forIn,
  get,
  find,
  cloneDeep,
  assign,
  keys,
  pickBy,
  pick,
  omit,
  isEmpty,
  omitBy,
  map,
  isNil,
  eq,
  forEach,
  findIndex,
  isString,
  split,
  join,
  isArray,
} from 'lodash'
import ModelServer from '../services/modelServer'
import selectStandardId from '../../../components/selectStandardId'

const OperateModelTreeDialog = () => {
  return import('../components/OperateModelTreeDialog')
}
const OperateModelDialog = () => {
  return import('../components/OperateModelDialog')
}

export default {
  name: 'modelBase',
  components: {
    OperateModelTreeDialog,
    OperateModelDialog,
    selectStandardId,
  },
  data() {
    return {
      menuTreeType: 'pr',
      currentStandardItemCode: '',
      standardList: [],
      standardDocumentCode: '',
      moduleConfig: {
        VUE_APP_STANDARD_ID: '',
        VUE_APP_CLASS_ID: '',
      },
      configDialogShow: false, // 配置功能弹窗
      // 页面信息 默认为模型库页面
      pageInfo: {
        pageTitle: '模型',
        materialType: 1,
      },
      // 表单搜索
      searchForm: {
        name: '',
        isRecursion: true,
      },
      // 模型库目录过滤
      treeKeyword: '',
      // 模型库树加载状态
      treeLoading: false,
      // 模型树数据
      treeData: [],
      // 当前选中节点
      currentTreeSelect: {},
      // 模型库数据
      tableData: [],
      // 分页参数
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      // 模型树弹框显隐
      showOperateSourceMaterialDialog: false,
      // 模型树弹框操作类型
      modelTreeProps: {
        visible: true,
        title: '新增模型库',
        editType: 'create',
      },
      // 模型树弹框表单
      modelTreeForm: {
        name: '',
      },
      // 模型弹框显隐
      showOperateModelDialog: false,
      // 模型弹框操作信息
      modelProps: {
        visible: true,
        title: '新增模型',
        editType: 'create',
      },
      // 模型弹框表单
      modelForm: {
        name: '',
        orderNumber: '',
        directoryId: '',
        lables: [],
        modelFile: [],
        modelClassName: '',
      },
      selection: [],
      // 分类树显隐
      treeStandBy: true,
      // 是否默认展开全部
      defaultExpandAll: false,
      // 当前选择模型
      seleteFile: {},
      // 表格数据加载状态
      tableLoading: false,
      // 批量上传
      showBatchUploadDialog: false,
      // 当前模型操作信息
      batchUploadProps: {
        visible: true,
        title: '批量上传模型',
        editType: 'create',
      },
      // 新增目录层级信息
      addDataInfo: {},
      // 默认展开
      defaultExpandIds: [''],
      // 导入组件显隐
      showUploadExcelDialog: false,
      // 导入描述
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
        downLoading: false, // 下载加载状态
        exportLoading: false, // 导出加载状态
      },
      // 文件下载加载状态
      downLoading: false,
      // 导出加载状态
      exportLoading: false,
      // 模型图片列表加载状态
      modleImageLoadInstance: null,
      // 当前激活node节点id
      currentNodeKey: '',
      // 请求实例
      requestInstance: null,
      // 目录请求实例
      directoryInstance: null,

      isTreeLazy: true, // 目录树是否开启懒加载模式
      currentTreeData: [], // 当前目录树数据
      treeDialogQuery: {
        standardId: '', // 标准库id
        parentId: '',
      }, // 目录树弹窗参数
    }
  },
  created() {
    this.standardList = JSON.parse(localStorage.getItem('standardList'))
    const currentStandard = localStorage.getItem('standardId')
    if (!this.standardList || !currentStandard) {
    }
    this.initData(currentStandard)
  },
  watch: {
    menuTreeType(val) {
      this.menuTreeType = val
      this.searchTree()
    },
    showOperateSourceMaterialDialog(bol) {
      if (bol) {
        this.modelTreeProps.visible = true
      }
    },
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    jumpPreviewRouter() {
      return (
        Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config?.jumpPreviewRouter ||
        '/visualization-cockpit/index'
      )
    },
    // 页面标题
    pageTitle() {
      return get(this.pageInfo, 'pageTitle')
    },
  },
  methods: {
    async initData(standardId) {
      const currentStandardItem = _.find(this.standardList, { id: standardId })
      this.currentStandardItemCode = currentStandardItem.code
      this.standardDocumentCode = `${currentStandardItem.code}_Document.code`
      await this.updateStandardId(standardId)
      this.searchList()
    },
    updateStandardList(list) {
      this.standardList = list
      this.initData(this.standardList[0].id)
    },
    async updateStandardId(val) {
      this.tableLoading = true
      const currentStandardItem = _.find(this.standardList, ['id', val])
      this.currentStandardItemCode = currentStandardItem.code
      this.standardDocumentCode = `${currentStandardItem.code}_Document.code`
      this.moduleConfig.VUE_APP_STANDARD_ID = val
      this.searchTree()
      const res = await ModelServer.getClassList({
        standard_id: val,
        data_type: 1,
      })
      if (res && res.data && res.code === 0) {
        const documentClass = _.filter(res.data, (item) => {
          return item.code === 'Document' && item.name === '文档'
        })
        const fl3dMasRes = await ModelServer.getClassList({
          standard_id: val,
          data_type: 1,
          parent_id: documentClass[0].id,
        })
        if (fl3dMasRes && fl3dMasRes.data && fl3dMasRes.data.length > 0 && fl3dMasRes.code === 0) {
          this.moduleConfig.VUE_APP_CLASS_ID = fl3dMasRes.data[0].id
          this.searchList()
        } else {
          this.tableData = []
          this.tableLoading = false
          this.page.pageTotal = 0
        }
      }
    },
    async getSearchTreeNode() {
      this.isTreeLazy = false
      this.treeStandBy = false
      this.treeLoading = true
      const res = await ModelServer.getTreeNodes({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        filter: this.treeKeyword, // 文档目录名称(模糊查询)
        isRoot: false, // 是否是根节点
      })
      this.treeLoading = false
      if (res && res.data && res.code === 0) {
        this.treeData = res.data
        this.treeStandBy = true
        if (this.treeKeyword) {
          await this.expandMatchingNodes()
        }
      }
    },
    /**
     * @description 目录树搜索
     */
    searchTree(type) {
      if (this.menuTreeType === 'pr') {
        this.getAllTreeNode(this.menuTreeType)
        return
      }
      if (type === 'search' && this.treeKeyword) {
        this.getSearchTreeNode()
        return
      }
      this.treeStandBy = false
      this.$nextTick(() => {
        this.isTreeLazy = true
        this.treeStandBy = true
      })
    },

    /**
     * @description 搜索后展开匹配节点的所有父节点
     */
    async expandMatchingNodes() {
      // 等待数据加载完成
      await this.$nextTick()

      if (!this.treeData || !this.treeData.length) return

      // 查找所有匹配节点及其父节点
      const expandedIds = []
      const findAndCollectNodes = (nodes, parentIds = []) => {
        nodes.forEach((node) => {
          const currentIds = [...parentIds, node.id]

          // 检查当前节点是否匹配搜索条件
          if (this.filterTree(this.treeKeyword, node)) {
            // 将当前节点及其所有父节点的ID添加到展开列表
            currentIds.forEach((id) => {
              if (id && !expandedIds.includes(id)) {
                expandedIds.push(id)
              }
            })
          }

          // 递归检查子节点
          if (node.childrens && node.childrens.length) {
            findAndCollectNodes(node.childrens, currentIds)
          }
        })
      }

      findAndCollectNodes(this.treeData)

      // 设置默认展开的节点
      this.defaultExpandIds = expandedIds

      // 强制重新渲染树组件以应用展开状态
      this.treeStandBy = false
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },

    /**
     * @description 目录树懒加载
     */
    async loadTreeData(node, resolve) {
      if (this.treeKeyword) {
        return
      }
      this.treeLoading = true
      const res = await ModelServer.getTreeNodes({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        filter: this.treeKeyword, // 文档目录名称(模糊查询)
        isRoot: node.level === 0, // 是否是根节点
        nodeId: node?.data?.id, // 当前节点id
      })
      this.treeLoading = false
      if (res && res.data && res.code === 0) {
        resolve(res.data)
        return
      }
      resolve([])
    },

    /**
     * @description 目录树加载所有数据
     * @param {String} fileType 显示的文件类型
     */
    async getAllTreeNode() {
      this.isTreeLazy = false
      this.treeStandBy = false
      this.treeLoading = true
      const payload = {
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        filter: this.treeKeyword, // 文档目录名称(模糊查询)
        isRoot: false, // 是否是根节点
        nodeId: '', // 当前节点id
        fileType: this.menuTreeType,
      }
      const res = await ModelServer.getTreeAllNodes(payload)
      this.treeLoading = false
      this.treeStandBy = true
      if (res && res.data && res.code === 0) {
        this.treeData = res.data
        console.log(this.treeData, '12')
        this.currentTreeData = [...res.data]

        // 如果有搜索关键词，展开所有匹配节点的父节点
        if (this.treeKeyword) {
          await this.expandMatchingNodes()
        }
      }
    },
    // 当前选中ids
    currentCheckModelIds() {
      return keys(pickBy(this.seleteFile, Boolean))
    },

    // 初始化表格数据
    getCheckList(tableData) {
      return map(tableData, (item) => {
        return assign(item, {
          // 绑定选择框值
          isCheck: get(this.seleteFile, item.id) || false,
          // 绑定缩略图路径
          pathUrl: item.pathUrl || '',
        })
      })
    },
    // 下载文件
    async downloadFile() {
      if (!get(this.currentCheckModelIds(), 'length')) {
        this.$message.warning('请选择下载文件')
        return
      }
      this.downLoading = true
      const res = await ModelServer.downloadDocumentFile({
        documentIds: [...this.currentCheckModelIds()],
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
      })
      this.downLoading = false
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '模型文件.zip',
          data: res,
        })
        this.seleteFile = this.$options.data().seleteFile
        this.tableData = this.getCheckList(this.tableData)
        this.$message.success('成功')
      }
    },
    // 下载缩略图base64
    async startDownloadImages(imageList) {
      this.modleImageLoadInstance = this.requestLimitFn(5)
      await Promise.all(
        map(imageList, (item) => {
          return this.modleImageLoadInstance.generator(() => {
            return this.getModelBase64(item)
          })
        })
      )
      this.modleImageLoadInstance = null
    },
    // 请求个数并行及顺序控制
    requestLimitFn(limit) {
      let queue = []
      let currentStatus = true
      let activeCount = 0
      // 执行下一个任务
      const next = () => {
        activeCount -= 1
        if (queue.length > 0) {
          const nextFn = queue.shift()
          // 当前为取消状态 结束任务执行
          if (!currentStatus) {
            next()
            return
          }
          nextFn()
        }
      }
      // 执行任务队列
      const run = async (fn, resolve, ...args) => {
        activeCount += 1
        try {
          if (!currentStatus) {
            resolve({})
          }
          const res = await fn(...args)
          resolve(res)
        } finally {
          next()
        }
      }
      // 任务队列初始化
      const enqueue = (fn, resolve, ...args) => {
        queue.push(run.bind(null, fn, resolve, ...args))
        if (activeCount < limit && queue.length > 0) {
          queue.shift()()
        }
      }
      // 任务添加
      const generator = async (fn, ...args) => {
        return new Promise((resolve) => {
          enqueue(fn, resolve, ...args)
        })
      }
      // 任务状态控制
      const requestController = (isRun = true) => {
        currentStatus = isRun
        queue = []
      }
      return { generator, requestController }
    },
    // 结束未完成请求
    initModelImageLoad() {
      if (!isEmpty(this.modleImageLoadInstance)) {
        this.modleImageLoadInstance.requestController(false)
        this.modleImageLoadInstance = null
      }
    },
    // 根据文件id获取缩略图
    async getModelBase64(fileInfo) {
      const { id } = fileInfo
      // 获取文件信息
      const res = await ModelServer.getDocumentFiles({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        id,
      })
      if (res?.length) {
        // 贴图
        const textureFile = find(res, (item) => {
          const fileInfos = item.fileName.split('.')
          return ['zip'].includes(fileInfos[fileInfos.length - 1].toLowerCase())
        })
        if (textureFile) {
          fileInfo.textureInfoId = textureFile.fileId
        }
        // 同时存在多个pprj及多个pr,使用pprj或pr中排序最靠前的模型
        const prFile = find(res, (item) => {
          const fileInfos = item.fileName.split('.')
          return ['pr', 'pprj'].includes(fileInfos[fileInfos.length - 1].toLowerCase())
        })
        if (prFile) {
          fileInfo.modelInfoId = prFile.fileId
        }
        const imgFile = find(res, (item) => {
          const fileInfos = item.fileName.split('.')
          return ['png', 'jpg', 'jpeg', 'webp', 'tiff', 'svg'].includes(
            fileInfos[fileInfos.length - 1].toLowerCase()
          )
        }) // 缩略图
        if (imgFile) {
          const fileRes = await ModelServer.getFileContent({
            id: imgFile.fileId,
          })
          if (fileRes) {
            const targetIndex = findIndex(this.tableData, ['id', id])
            if (targetIndex === -1) {
              return Promise.resolve()
            }
            const reader = new FileReader()
            reader.onload = () => {
              this.$set(this.tableData[targetIndex], 'pathUrl', `${reader.result}`)
            }
            reader.readAsDataURL(fileRes)
          }
        }
      }
      return Promise.resolve()
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await ModelServer.downloadTemplate({
        cateCode: 'Document',
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: `${this.pageTitle}导入模板.xlsx`,
          data: res,
        })
      }
    },
    // 下载导入结果
    async exportResults() {
      if (this.uploadData) {
        this.downLoadBlob({
          name: `${this.pageTitle}导入结果.xlsx`,
          data: this.uploadData,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      forIn({ file }, (value) => {
        formData.append('file', value)
      })
      formData.append('standardId', this.moduleConfig.VUE_APP_STANDARD_ID)
      formData.append('cateCode', 'Document')
      const res = await ModelServer.importDynamicTableData(formData)
      this.uploadFileProps.btnLoading = false
      if (res) {
        this.uploadFileProps.active = 2
        // 导出结果
        this.uploadData = res
        this.$message.success('成功')
      }
    },
    // 导入
    importModel() {
      // 导入默认为下载模板
      this.uploadFileProps.active = 0
      this.uploadFileProps.visible = true
      this.showUploadExcelDialog = true
      this.uploadData = null
    },
    // 导出
    async exportModel() {
      this.exportLoading = true
      const ids = this.currentCheckModelIds()
      const res = await ModelServer.exportDynamicTableData({
        cateCode: 'Document',
        ids,
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
      })
      this.exportLoading = false
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: `${this.pageTitle}.xlsx`,
          data: res,
        })
        this.seleteFile = this.$options.data().seleteFile
        this.tableData = this.getCheckList(this.tableData)
        this.$message.success('导出成功')
      }
    },
    // 模型树弹框关闭回调
    async closeModelTreeDialog(isRefresh) {
      this.modelTreeProps.visible = false
      this.showOperateSourceMaterialDialog = false
      this.searchTree('search')
      if (!isRefresh) return
      // 默认展开新增目录层级
      this.treeStandBy = false
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 模型弹框关闭回调
    closeModelDialog(isUpdated) {
      this.modelProps.visible = false
      this.showOperateModelDialog = false
      // 非取消操作刷新数据
      if (isUpdated) {
        this.searchList()
      }
    },
    // 批量上传
    batchUpload() {
      this.showBatchUploadDialog = true
      this.batchUploadProps = assign(this.$options.data().batchUploadProps, {
        title: `批量上传${this.pageTitle}`,
      })
    },

    async openModelView(row) {
      const fullScreenParam = this.basePath
        ? {
            ShowClassicTop: false,
            ShowClassicLeft: false,
          }
        : {}
      window.routerTrigger = 'noCache'
      // 云渲染全屏版本
      const routerData = this.$router.resolve({
        path: `${this.basePath}/fullscreen/model-doc-view${
          Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config?.isVulkan
            ? '-vk'
            : ''
        }/index`,
        query: {
          modelInfoId: row.modelInfoId,
          textureInfoId: row.textureInfoId || '',
          documentId: row.id,
          title: row[this.standardDocumentCode],
          standardId: this.moduleConfig.VUE_APP_STANDARD_ID,
          classId: row.class_id,
          isVersion: '0', // 是否是历史版本查看
          token: localStorage.getItem('authorization'),
          ...fullScreenParam,
        },
      })
      localStorage.setItem('currentViewFileTitle', row[this.standardDocumentCode])
      window.open(routerData.href, '_blank')
    },
    // 模型选择事件
    checkBoxChange(currentVal) {
      const id = get(currentVal, 'id')
      const isCheck = get(currentVal, 'isCheck')
      if (isNil(id) || isNil(isCheck)) {
        return
      }
      this.seleteFile[id] = isCheck
    },
    // 收起、展开全部
    operateTree(bool) {
      this.defaultExpandIds = []
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 自定义树过滤
    filterTree(value, data) {
      return data.name.includes(value)
    },
    // 获取模型树
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await this.directoryInstance.getTree()
      if (!err && !isNil(res)) {
        this.treeData = [{ name: '根目录', id: '', children: res }]
      }
      this.treeLoading = false
    },

    // 模型库树点击
    handleNodeClick(node) {
      this.currentTreeSelect = node
      this.searchList()
    },
    // 表格按钮事件
    handleCommand(command, node, data) {
      this.treeDialogQuery = {
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        parentId: data?.id,
      }
      switch (command) {
        case 'edit':
          this.editSourceMaterial(data)
          break
        case 'delete':
          this.deleteSourceMaterial(node, data)
          break
        case 'create':
          this.addSourceMaterial(node, data)
          break
        default:
          break
      }
    },
    // 修改模型库
    editSourceMaterial(row) {
      this.modelTreeProps = assign(this.$options.data().modelTreeProps, {
        title: '编辑文件夹',
        editType: 'edit',
      })
      this.modelTreeForm = cloneDeep(row)
      this.showOperateSourceMaterialDialog = true
    },
    // 新增模型
    createModelBase() {
      this.showOperateModelDialog = true
      this.modelProps = assign(this.$options.data().modelProps, {
        title: '新增文件夹',
      })
      this.modelForm = this.$options.data().modelForm
    },
    // 批量删除
    batchDeleteModelBase() {
      if (!this.currentCheckModelIds().length) {
        this.$message.warning('请先勾选模型')
        return
      }
      this.$confirm('此操作将永久删除，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const ids = this.currentCheckModelIds()
        const res = await ModelServer.deleteDynamicData(
          map(ids, (id) => {
            return {
              classId: this.moduleConfig.VUE_APP_CLASS_ID,
              standardId: this.moduleConfig.VUE_APP_STANDARD_ID,
              dataId: id,
              type: 3, // 固定
            }
          })
        )
        if (res?.code === 0) {
          this.$message.success('删除成功')
          this.seleteFile = this.$options.data().seleteFile
          this.findList()
        }
      })
    },
    // 编辑模型
    editModelBase(row) {
      if (!this.$hasAccess('update')) {
        return
      }
      this.showOperateModelDialog = true
      this.modelProps = assign(this.$options.data().modelProps, {
        title: `编辑${this.pageTitle}`,
        editType: 'edit',
      })
      this.modelForm = { ...row }
    },
    // 删除模型
    deleteModelBase(id) {
      if (!this.$hasAccess('delete')) {
        return
      }
      this.$confirm('此操作将永久删除，是否继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        // const [err] = await this.requestInstance.callDelete(id)
        const res = await ModelServer.deleteDynamicData([
          {
            classId: this.moduleConfig.VUE_APP_CLASS_ID,
            standardId: this.moduleConfig.VUE_APP_STANDARD_ID,
            dataId: id,
            type: 3, // 固定
          },
        ])
        if (res?.code === 0) {
          this.$message.success('删除成功')
          this.findList()
        }
      })
    },
    // 新增模型库
    addSourceMaterial(node, data) {
      this.treeDialogQuery = {
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        parentId: data ? data.id : '00000000-0000-0000-0000-000000000000',
      }
      this.showOperateSourceMaterialDialog = true
    },
    // 重置搜索
    resetSearch() {
      this.currentTreeSelect = this.$options.data().currentTreeSelect
      this.searchForm = this.$options.data().searchForm
      this.searchList()
    },
    // 带条件情况分页搜索
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    // 列表搜索
    async findList() {
      this.tableLoading = true
      this.initModelImageLoad()
      console.log(this.moduleConfig, 'moduleConfig')
      const res = await ModelServer.getTypeDynamicTable({
        standardId: this.moduleConfig.VUE_APP_STANDARD_ID, // 标准库id
        sorting: '',
        cateCode: 'Document', // 文档类别编码
        fileType: 'pr', // 文件类型
        classId: [this.moduleConfig.VUE_APP_CLASS_ID],
        filter: this.searchForm.name,
        folderId: this.currentTreeSelect?.id, // 目录树节点id
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        if (res.data) {
          this.tableData = this.getCheckList(res.data)
          this.startDownloadImages(this.tableData)
        } else {
          this.tableData = []
        }
        this.page.pageTotal = res.totalCount
      }
    },
    // 删除模型库
    async deleteSourceMaterial(node, data) {
      await this.findList()
      let num = 0
      const id = data.id
      if (!this.tableData.length) {
        this.$confirm('您确定要删除对应的目录', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              num = num + 1
              if (num === 1) await this.deleteTreeNode(id, node, data)
              instance.confirmButtonLoading = false
              done()
            } else {
              done()
            }
          },
        }).catch(() => {})
        return
      }
      this.$confirm(
        '该目录下包含有文档，如果强行删除，会将该目录下的文档删除，是否确定要删除所选择的目录',
        '提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.deleteTreeNode(id, node, data)
      })
    },

    // 删除tree节点操作
    async deleteTreeNode(id, node, data) {
      if (!id) return
      const res = await ModelServer.deleteTreeNodeById({
        id,
      })
      if (res && res.code === 0) {
        const parent = node.parent
        const children = parent.childNodes || parent.data
        const index = children.findIndex((d) => {
          return d.key === data.folderId
        })
        children.splice(index, 1)
        this.$message({
          type: 'success',
          message: res.msg,
          duration: 2000,
        })
        this.treeStandBy = false
        this.$nextTick(() => {
          this.treeStandBy = true
        })
      }
    },

    downLoadBlob(
      arg = {
        name: '下载文件.xlsx',
        data: '',
      }
    ) {
      const blob = new Blob([arg.data])
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${arg.name}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
  },
  deactivated() {
    this.initModelImageLoad()
  },
}
</script>
<style>

.el-dropdown-menu__item.active {
  color: #409eff !important;
}

</style>
<style scoped lang="scss">

::v-deep .el-card__body {
  height: calc(100%);
}
.card__body--nopadding ::v-deep .el-card__body {
  padding: 10px;
}
// ::v-deep .el-card.is-always-shadow,
// .el-card.is-hover-shadow:focus,
// .el-card.is-hover-shadow:hover {
//   box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%) !important;
// }
::v-deep .el-card .el-card,
.el-dialog .el-card {
  border: 1px solid var(--lineBorderColor) !important;
}
.to-model-preview {
  cursor: pointer;
}
.model_message_wrap {
  background-color: #f5f5f5 !important;
  color: #000000 !important;
  ::v-deep .el-checkbox__inner {
    border-color: #000000 !important;
  }
}

.modelTree-tree {
  height: calc(100% - 84px);
}

</style>
